<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataOverview")
    h1.title Eigentümer
    .sub-headline Hier können Sie alle Eigentümer verwalten.
    
    .button-wrapper.margin-top      
      b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'DataOwnerNew'})") Neuen Eigentümer anlegen

    .card.margin-top
      .main
        b-table(:data="owners"
                default-sort-direction="asc"
                default-sort="fullName"
                hoverable)
          b-table-column(field='fullName' label='Eigentümer' sortable, v-slot="props")
            | {{props.row.fullName}}
          b-table-column(label='Objektanzahl' sortable, v-slot="props")
            | {{props.row.rentObjects.length}}
          b-table-column(label='Objektkürzel' sortable, v-slot="props")
            a(v-for="r, idx in props.row.rentObjects" @click="$router.push('/data/rent-objects/edit/'+r.id)") {{r.code}}{{idx !== props.row.rentObjects.length -1 ? ', ' : ''}}
          //- b-table-column(field='address.street' label='Straße' sortable, v-slot="props")
          //-   | {{props.row.address.street}}
          //- b-table-column(field='address.zip' label='PLZ' sortable, v-slot="props")
          //-   | {{props.row.address.zip}}
          //- b-table-column(field='address.city' label='Stadt' sortable, v-slot="props")
          //-   | {{props.row.address.city}}
          b-table-column(v-slot="props" width=120)
            div
              b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                b-button(icon-right="pencil", type="is-secondary" @click="$router.push({ name: 'DataOwnerEdit', params: { id: props.row.id } })")
              .spacer.sm.inline
              b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                b-button(icon-right="close", type="is-danger" @click="deleteOwner(props.row)" :disabled="props.row.rentObjects.length > 0")
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    owners() {
      return this.$store.state.owners.all;
    },
  },
  methods: {
    deleteOwner(row) {
      this.$buefy.dialog.confirm({
        title: "Eigentümer löschen",
        message: `Sind Sie sicher, dass Sie diesen Eigentümer <b>${row.fullName}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Eigentümer löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("owners/delete", { id: row.id });
            this.$buefy.toast.open("Eigentümer gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Eigentümer konnte nicht gelöscht werden."
            );
          }
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("owners/findAll");
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>